
<div class="hr-layout">
  <!-- <app-hygine-sidebar></app-hygine-sidebar> -->
  <div class="hr-main-content">
    <div class="hr-report-panel" >
    <div class="hr-page-outer">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="hr-page-wrap">
          <div class="hr-header-row">
            <h1 class="hr-main-title">Ticketing</h1>
            <div class="hr-filter-bar-wrapper">
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openState(); focusStateInput()"
                  [class.hr-trigger-open]="stateOpen">
                  <span class="hr-trigger-text">{{ selectedStateName || 'Select State' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="stateOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search State"
                      [(ngModel)]="stateQuery" (keyup)="filterStates()" #searchStateInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let s of filteredStateList">
                      <ul class="att-dropdown-item" (mousedown)="selectState(s); $event.preventDefault()"
                        [class.att-item-selected]="selectedStateId === (s.stateId ?? s.id)">
                        <li class="att-item-text">{{ s.stateName ?? s.name ?? s }}</li>
                        <li><i *ngIf="selectedStateId === (s.stateId ?? s.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openZone(); focusZoneInput()"
                  [class.hr-trigger-open]="zoneOpen">
                  <span class="hr-trigger-text">{{ selectedZoneName || 'Select Zone' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="zoneOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search Zone"
                      [(ngModel)]="zoneQuery" (keyup)="filterZones()" #searchZoneInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let z of filteredZoneList">
                      <ul class="att-dropdown-item" (mousedown)="selectZone(z); $event.preventDefault()"
                        [class.att-item-selected]="selectedZoneId === (z.ZONE_ID ?? z.zoneId ?? z.id)">
                        <li class="att-item-text">{{ z.ZONE_NAME ?? z.zoneName ?? z.name ?? z }}</li>
                        <li><i *ngIf="selectedZoneId === (z.ZONE_ID ?? z.zoneId ?? z.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openCity(); focusCityInput()"
                  [class.hr-trigger-open]="cityOpen">
                  <span class="hr-trigger-text">{{ selectedCityName || 'Select City' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="cityOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search City"
                      [(ngModel)]="cityQuery" (keyup)="filterCities()" #searchCityInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let c of filteredCityList">
                      <ul class="att-dropdown-item" (mousedown)="selectCity(c); $event.preventDefault()"
                        [class.att-item-selected]="selectedCityId === (c.CITY_ID ?? c.cityId ?? c.id)">
                        <li class="att-item-text">{{ c.CITY_NAME ?? c.cityName ?? c.name ?? c }}</li>
                        <li><i *ngIf="selectedCityId === (c.CITY_ID ?? c.cityId ?? c.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openCampus(); focusCampusInput()"
                  [class.hr-trigger-open]="campusOpen">
                  <span class="hr-trigger-text">{{ selectedCampusName || 'Select Campus' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="campusOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search Campus"
                      [(ngModel)]="campusQuery" (keyup)="filterCampuses()" #searchCampusInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let c of filteredCampusList">
                      <ul class="att-dropdown-item" (mousedown)="selectCampus(c); $event.preventDefault()"
                        [class.att-item-selected]="selectedCampusId === (c.CAMPUS_ID ?? c.campusId ?? c.id)">
                        <li class="att-item-text">{{ c.CAMPUS_NAME ?? c.campusName ?? c.name ?? c }}</li>
                        <li><i *ngIf="selectedCampusId === (c.CAMPUS_ID ?? c.campusId ?? c.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openBuilding(); focusBuildingInput()"
                  [class.hr-trigger-open]="buildingOpen">
                  <span class="hr-trigger-text">{{ selectedBuildingName || 'Select Building' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="buildingOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search Building"
                      [(ngModel)]="buildingQuery" (keyup)="filterBuildings()" #searchBuildingInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let b of filteredBuildingList">
                      <ul class="att-dropdown-item" (mousedown)="selectBuilding(b); $event.preventDefault()"
                        [class.att-item-selected]="selectedBuildingId === (b.BUILDING_ID ?? b.buildingId ?? b.id)">
                        <li class="att-item-text">{{ b.BUILDING_NAME ?? b.buildingName ?? b.name ?? b }}</li>
                        <li><i *ngIf="selectedBuildingId === (b.BUILDING_ID ?? b.buildingId ?? b.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="hr-filter-bar-spacer"></div>
              <button type="button" class="hr-search-btn" (click)="onSearch()">
                <i class="fa fa-search"></i> Search
              </button>
            </div>
          </div>

         
          <div class="row hr-cards-row">
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-purple" [class.hr-card-active]="activeDateTab === 'today'"
                (click)="selectDateTab('today')" role="button" tabindex="0">
                <i class="fa fa-camera hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Today</span>
                  <span class="hr-summary-value">{{ ticketTodayTotalCount }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-orange" [class.hr-card-active]="activeDateTab === 'yesterday'"
                (click)="selectDateTab('yesterday')" role="button" tabindex="0">
                <i class="fa fa-calendar-minus hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Yesterday</span>
                  <span class="hr-summary-value">{{ ticketYesterdayTotalCount }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-green" [class.hr-card-active]="activeDateTab === 'last7'"
                (click)="selectDateTab('last7')" role="button" tabindex="0">
                <i class="fa fa-calendar-week hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Last 7 day's</span>
                  <span class="hr-summary-value">{{ ticketLast7DaysTotalCount }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-red" [class.hr-card-active]="activeDateTab === 'month'"
                (click)="selectDateTab('month')" role="button" tabindex="0">
                <i class="fa fa-calendar-alt hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">This Month</span>
                  <span class="hr-summary-value">{{ ticketThisMonthTotalCount }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- One white card: tabs, content, grid, pagination inside (same as dashboard) -->
          <div class="hr-main-card">
            <!-- Tabs + Compare -->
            <div class="hr-tabs-row">
              <div class="hr-date-tabs">
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'today'"
                  (click)="selectDateTab('today')">Today ({{ ticketTodayTotalCount }})</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'yesterday'"
                  (click)="selectDateTab('yesterday')">Yesterday ({{ ticketYesterdayTotalCount }})</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'last7'"
                  (click)="selectDateTab('last7')">Last 7 days ({{ ticketLast7DaysTotalCount }})</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'month'"
                  (click)="selectDateTab('month')">This Month ({{ ticketThisMonthTotalCount }})</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'custom'"
                  (click)="selectDateTab('custom')">Custom Date{{ customStartDate && customEndDate ? ' (' + (customDateRangeTotalCount) + ')' : '' }}</button>
              </div>
              <!-- <button type="button" class="hr-compare-btn" (click)="showCompare = !showCompare">Compare</button> -->
            </div>
            <!-- Custom Date: Quick-Links style trigger + popover (no input field); date range up to today -->
            <div class="hr-custom-date-wrap" [class.hr-custom-date-popover-open]="customDatePopoverOpen" *ngIf="activeDateTab === 'custom'" #customDateWrap>
              <div class="hr-custom-date-trigger-wrap">
                <button type="button" class="hr-custom-date-trigger" (click)="toggleCustomDatePopover()"
                  [class.hr-trigger-open]="customDatePopoverOpen" aria-haspopup="true" [attr.aria-expanded]="customDatePopoverOpen">
                  <i class="fa fa-calendar-alt hr-trigger-icon"></i>
                  <span class="hr-trigger-text">{{ customDateTriggerLabel }}</span>
                  <i class="fa fa-chevron-down hr-trigger-chevron"></i>
                </button>
              </div>
              <div class="hr-custom-date-popover" *ngIf="customDatePopoverOpen" #customDatePopover (mousedown)="$event.stopPropagation()">
                <div class="hr-custom-date-popover-header">
                  <i class="fa fa-calendar-alt hr-popover-header-icon"></i>
                  <span class="hr-custom-date-popover-title">Date range</span>
                </div>
                <p class="hr-custom-date-popover-subtitle">Select start and end date (up to today)</p>
                <div class="hr-custom-date-calendar-wrap">
                  <input #dateRangeInput type="text" class="hr-date-range-input-hidden" readonly placeholder="Pick dates">
                </div>
              </div>
            </div>
            <div class="hr-tabs-row hr-status-tabs-row">
              <div class="hr-status-tabs">
                <button type="button" class="hr-status-tab" [class.hr-status-tab-active]="activeStatusTab === 'pending'"
                  (click)="selectStatusTab('pending')">Pending ({{ ticketActivePeriodSummary.pending }})</button>
                <button type="button" class="hr-status-tab" [class.hr-status-tab-active]="activeStatusTab === 'inProgress'"
                  (click)="selectStatusTab('inProgress')">In Progress ({{ ticketActivePeriodSummary.inProgress }})</button>
                <button type="button" class="hr-status-tab" [class.hr-status-tab-active]="activeStatusTab === 'resolved'"
                  (click)="selectStatusTab('resolved')">Resolved ({{ ticketActivePeriodSummary.resolved }})</button>
              </div>
            </div>
            <h2 class="hr-content-heading">Tickets ({{ ticketBuildingCards.length }})</h2>
            <div class="hr-pictures-grid" [class.hr-grid-custom-active]="activeDateTab === 'custom'" (click)="onPicturesGridClick($event)">
              <div class="hr-pic-card" *ngFor="let t of paginatedTicketCards; let i = index" [attr.data-card-index]="(currentPage - 1) * pageSize + i" role="button" tabindex="0" (keydown.enter)="onCardClick(t)">
                <div class="hr-pic-placeholder" >
                  <img *ngIf="t.imageUrl && !hasCardImageError(t)" [src]="t.imageUrl" alt="Ticket" class="hr-pic-img"
                       (error)="onCardImageError(t)">
                  <div *ngIf="!t.imageUrl || hasCardImageError(t)" class="hr-pic-noimage">
                    <i class="fa fa-image"></i>
                  </div>
                </div>
                <div *ngIf="t.campusName" class="hr-pic-campus-below">
                  <span class="hr-pic-campus-text">{{ t.campusName }}</span>
                  <img *ngIf="t.latitude && t.longitude && t.latitude !== 0 && t.longitude !== 0"
                    [src]="mapIconPath"
                    alt=""
                    class="hr-pic-location-icon hr-pic-location-clickable"
                    (click)="$event.stopPropagation(); openMap(t.latitude, t.longitude)"
                    role="button"
                    tabindex="0"
                    (keydown.enter)="$event.stopPropagation(); openMap(t.latitude, t.longitude)">
                </div>
                <div class="hr-pic-created-by" *ngIf="t.createdBy || t.createdByDesignation || t.createdByMobile">
                  <div *ngIf="t.createdBy" class="hr-pic-created-by-name">{{ t.createdBy }}</div>
                  <div *ngIf="t.createdByDesignation" class="hr-pic-created-by-designation">{{ t.createdByDesignation }}</div>
                  <div *ngIf="t.createdByMobile" class="hr-pic-created-by-mobile">{{ t.createdByMobile }}</div>
                </div>
                <div class="hr-pic-info">
                  <div class="hr-pic-ticket-meta" *ngIf="t.categoryName || t.ticketId != null || t.createdOn">
                    <span class="hr-pic-category" *ngIf="t.categoryName">{{ t.categoryName }}</span>
                    <span class="hr-pic-id-date" *ngIf="t.ticketId != null || t.createdOn">
                      <!-- <span *ngIf="t.ticketId != null">#{{ t.ticketId }}</span> -->
                      <!-- <span *ngIf="t.ticketId != null && t.createdOn" class="hr-pic-sep">·</span> -->
                      <span *ngIf="t.createdOn">{{ t.createdOn }}</span>
                    </span>
                  </div>
                  <!-- <span class="hr-pic-meta">
                    <button *ngIf="t.pending > 0 && activeStatusTab === 'pending'"
                      type="button"
                      class="hr-ticket-status-btn hr-ticket-status-pending">
                      Pending
                    </button>
                    <button *ngIf="t.inProgress > 0 && activeStatusTab === 'inProgress'"
                      type="button"
                      class="hr-ticket-status-btn hr-ticket-status-inprogress">
                      In Progress
                    </button>
                    <button *ngIf="t.resolved > 0 && activeStatusTab === 'resolved'"
                      type="button"
                      class="hr-ticket-status-btn hr-ticket-status-resolved">
                      Resolved
                    </button>
                  </span> -->
                </div>
              </div>
              <p *ngIf="ticketBuildingCards.length === 0" class="hr-no-pictures">No tickets found.</p>
            </div>

            <!-- <div *ngIf="ticketDetailList.length" class="hr-ticket-detail-list">
              <h3 class="hr-content-subheading">
                {{ ticketDetailStatus | uppercase }} Tickets ({{ ticketDetailList.length }})
              </h3>
              <div class="hr-ticket-detail-item" *ngFor="let d of ticketDetailList">
                <div class="hr-ticket-detail-left">
                  <div class="hr-ticket-detail-title">{{ d.categoryName }} - {{ d.blockName }} {{ d.floorNumber }} {{ d.roomNo }}</div>
                  <div class="hr-ticket-detail-meta">
                    <span>Priority: {{ d.priority }}</span>
                    <span>Created: {{ d.createdOn }}</span>
                  </div>
                  <div class="hr-ticket-detail-remarks">{{ d.remarks }}</div>
                </div>
                <div class="hr-ticket-detail-right">
                  <div>Assigned To: <strong>{{ d.assignedTo }}</strong></div>
                  <div>Created By: <strong>{{ d.createdByEmp }}</strong></div>
                </div>
              </div>
            </div> -->

            

            <!-- Pagination: 10 cards per page -->
            <div class="hr-pagination" *ngIf="ticketBuildingCards.length > 0 && totalPages > 1">
              <button type="button" class="hr-page-btn" [disabled]="currentPage <= 1"
                (click)="setPage(currentPage - 1)">Previous</button>
              <ng-container *ngFor="let page of pageNumbers">
                <button type="button" class="hr-page-num" [class.hr-page-active]="currentPage === page"
                  (click)="setPage(page)">{{ page }}</button>
              </ng-container>
              <button type="button" class="hr-page-btn" [disabled]="currentPage >= totalPages"
                (click)="setPage(currentPage + 1)">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
  <!-- <div class="hr-compare-panel" *ngIf="showCompare">
    <app-hygiene-compare (back)="showCompare = false"></app-hygiene-compare>
  </div> -->
  </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
